import template from './error.html';
import './error.scss';

export const errorPageComponent = {
    template,
    controller: class ErrorController {
        constructor(auth0AuthService) {
            'ngInject';

            this.auth0AuthService = auth0AuthService;
        }

        logout() {
            this.auth0AuthService.logout();
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/error/error.component.js